import { UserStatusOptions } from '../enums/user-status-options';
import { IUserStatus } from '../interfaces/user-status';

export function statusIncludesSalesNeverLoggedIn(status: IUserStatus[]): boolean {
  if (!status || !status.length) {
    return false;
  }

  return status.some((status) => status.status === UserStatusOptions.salesNeverLoggedIn);
}

export function statusIncludesPasswordEmailNotSent(status: IUserStatus[]): boolean {
  if (!status || !status.length) {
    return false;
  }

  return status.some((status) => status.status === UserStatusOptions.passwordEmailNotSent);
}
